import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let singleChoicePicker = class singleChoicePicker extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], singleChoicePicker.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], singleChoicePicker.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], singleChoicePicker.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], singleChoicePicker.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], singleChoicePicker.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], singleChoicePicker.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], singleChoicePicker.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], singleChoicePicker.prototype, "dataChage", null);
singleChoicePicker = __decorate([Component({
  name: "singleChoicePicker"
})], singleChoicePicker);
export default singleChoicePicker;